const state = {
  outlets: null
}

const getters = {
  outlets: state => state.outlets
}

const mutations = {
  SET_OUTLETS (state, outlets) {
    state.outlets = outlets
  }
}

export default {
  state,
  getters,
  mutations
}
